


















import Vue from "vue";
export default Vue.extend({
  props: ["title"],

  data() {
    return {
      collapsed: false,
    };
  },

  methods: {
    toggleCollapse() {
      this.collapsed = !this.collapsed;
    },
  },
});
